import { Text } from '@vitvio/design-system';
import { formatMinutes, parseISOToDate } from '@vitvio/helpers';
import { CountdownTimer } from '@vitvio/surgery-monitor-components';

interface Props {
  determinedEndTime: string;
  status: string;
  dynamicDurationMinutes: number | null | undefined;
  isJobUnclosed: boolean | null | undefined;
}
export function TimerContentTimer({ determinedEndTime, status, dynamicDurationMinutes, isJobUnclosed }: Props) {
  const activeFontStyle = {
    fontSize: '48px',
    fontWeight: '600',
    lineHeight: '48px',
  };
  const parsedTargetTime = parseISOToDate(determinedEndTime);

  switch (status) {
    case 'SCHEDULED':
      return (
        <>
          <Text fontSize={'38px'} fontWeight={'600'} lineHeight={'48px'}>
            {/* confirm that we should ALWAYS display dynamicDurationMinutes ... */}
            {dynamicDurationMinutes ? formatMinutes(dynamicDurationMinutes) : '--:--'}
          </Text>
          <Text fontSize={'smaller'} fontWeight={'medium'}>
            Planned duration
          </Text>
        </>
      );
    case 'RUNNING':
      return (
        <>
          <Text fontSize={'38px'} fontWeight={'600'} sx={activeFontStyle}>
            {parsedTargetTime && !isJobUnclosed ? (
              <CountdownTimer targetTime={parsedTargetTime} showSeconds={false} labelWhenFinished="--:--" />
            ) : (
              '--:--'
            )}
          </Text>
          <Text fontSize={'smaller'} fontWeight={'medium'}>
            Duration remaining
          </Text>
        </>
      );
    default:
      return (
        <>
          <Text fontSize={'38px'} fontWeight={'600'}>
            --:--
          </Text>
          <Text fontSize={'smaller'} fontWeight={'medium'}>
            Duration remaining
          </Text>
        </>
      );
  }
}
